import { render } from "./dialogCustomer.vue?vue&type=template&id=ab10b45e&scoped=true"
import script from "./dialogCustomer.vue?vue&type=script&lang=js"
export * from "./dialogCustomer.vue?vue&type=script&lang=js"

import "./dialogCustomer.vue?vue&type=style&index=0&id=ab10b45e&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab10b45e"]])

export default __exports__